module.exports = __webpack_public_path__ + "img/win.af815457.png";